<template>
  <Header>
    <template v-slot:title>天聖閣の特徴</template>
    <template v-slot:subtitle>Feature</template>
    <template v-slot:leadtext>
      大切な人の旅立ちを
      <br />
      厳かに格式高くお送りします。
    </template>
    <template v-slot:text>
      大切な人の死を悼み、おひとりお一人が最期のお別れを告げる聖なる空間。
      <br />
      上質のサービスとおもてなしの心で、ご会葬の方々をお迎えし、大切な人への想いを伝える心温まるセレモニーをお手伝いさせていただきます。
    </template>
  </Header>
  <section id="contents">
    <div class="feature-wrap">
      <div class="feature-item">
        <h4>家族葬から社葬まで、葬儀の大小問わずご利用いただけます。</h4>
        <p>
          ご家族だけのご葬儀からご会葬の方々が多い社葬まで、ご葬家のご要望に合わせて幅広く対応いたします。
        </p>
      </div>
      <div class="feature-item">
        <h4>安心の総額プランにて、最適な御葬儀を提案いたします。</h4>
        <p>
          安心してお任せいただけるよう、総額プランにてご案内させていただいております。また、返礼品やお食事も、ご要望にあわせてご用意させていただきます。
        </p>
      </div>
      <div class="feature-item">
        <h4>
          1日1葬限定の貸し切りで、大切な人との時間をお過ごしいただけます。
        </h4>
        <p>
          御葬儀は1日1組までの貸し切りとなっており、他の喪家様への気遣いの心配がございません。
          また親族控室、浴室や寝具等すべて準備しておりますので、一晩中大切な人の傍に寄り添えます。
        </p>
      </div>
      <div class="feature-item">
        <h4>真心をこめて、故人様を丁寧にお送りいたします。</h4>
        <p class="flex">
          <span>
            天聖閣では故人様を大切に送りたいという想いからご納棺の際、白装束を真綿で手作りし、装飾いたします。
            白は清らかなイメージがあり、きれいな状態で浄土で出発してほしいという想いで作らせていただきます。
          </span>

          <span>
            <img src="@/assets/images/feature/img01.jpg" alt="白装束" />
          </span>
        </p>
      </div>
      <div class="feature-item">
        <h4>葬儀から初盆まで、責任をもってお手伝いいたします。</h4>
        <p>
          通夜・葬儀告別式から四十九日・初盆まで、経験豊富なスタッフが責任をもってお手伝いいたします。
        </p>
      </div>
      <div class="feature-item">
        <h4>天草に3斎場。地域に寄り添ったサービスをご提供いたします。</h4>
        <p>
          本渡・五和・苓北の3つの斎場にて、365日24時間ご対応を行っております。
          地域の皆様に寄り添い、ご安心・ご信頼いただけるサービスをご提供いたします。
        </p>
      </div>
    </div>
  </section>
  <ContactSection></ContactSection>
  <Footer></Footer>
</template>
<script>
import Header from "@/components/PartsPageHeader.vue";
import ContactSection from "@/components/PartsContact.vue";
import Footer from "@/components/PartsFooter.vue";
export default {
  components: {
    Header,
    ContactSection,
    Footer,
  },
  setup() {},
};
</script>
<style lang="scss" scoped>
#contents {
  width: 100%;
  padding: 0 1rem;
  margin: 0 auto;
  padding-bottom: 80px;
  .feature-wrap {
    background-color: white;
    padding: 4rem 1rem;
    max-width: $maxwidth;
    margin: 0 auto;
    counter-reset: section;
    @include tb {
      padding: 2.5rem 1rem;
    }
    .feature-item {
      margin: 0 auto;
      max-width: 880px;
      padding-left: 6rem;
      position: relative;
      margin-bottom: 4rem;
      @include tb {
        padding: 3.5rem 0 0 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
      &:before {
        counter-increment: section 1;
        content: counter(section, decimal-leading-zero) ".";
        position: absolute;
        left: 0;
        color: $color-hondo;
        font-size: 3rem;
        @include tb {
          font-size: 2rem;
          top: 0;
          text-align: center;
          width: 100%;
        }
      }
      h4 {
        font-size: 1.5rem;
        border-bottom: 1px solid #ccc;
        line-height: 1.5;
        padding-top: 0.25em;
        padding-bottom: 1.5rem;
        margin-bottom: 1.5rem;
        @include tb {
          font-size: 1.25rem;
        }
      }
      p {
        line-height: 2;
        &.flex {
          display: flex;
          position: relative;
          gap: 2rem;
          @include tb {
            flex-direction: column;
          }
          span {
            width: 70%;
            @include tb {
              width: auto;
            }
          }
          span:nth-child(2) {
            width: 30%;
            @include tb {
              width: auto;
            }
            img {
              width: 100%;
              height: auto;
            }
          }
        }
      }
    }
  }
}
</style>
